import { Divider, Grid } from '@mui/material'
import { HearingSummaryProps } from 'components/HearingSummary'
import { StyledSpan as Span } from 'components/HearingSummary/styles'
import Label from 'components/Label'
import React from 'react'
import { HearingSummaryType } from 'types/hearing-summary.type'
import { CircumstanceGroup } from '../CircumstancesGroup'
import { GeneralDataGroup } from '../GeneralDataGroup'
import { IdentificationGroup } from '../IdentificationGroup'
import { InfractionGroup } from '../InfractionGroup'
import { StyledLabelHeading } from '../Header/styles'

import 'react-quill/dist/quill.snow.css'

export const SummaryData: React.FC<HearingSummaryProps<HearingSummaryType>> = ({ data }) => {
  const { dadosGerais, identAdolescente, circFatoApreensao, narrativa } = data

  return (
    <Grid container spacing={2} rowSpacing={2}>
      <Grid item xs={12} sx={{ mb: 2 }}>
        <GeneralDataGroup data={dadosGerais} />
      </Grid>
      <Grid item xs={12} sx={{ mb: 2 }}>
        <IdentificationGroup data={identAdolescente} />
      </Grid>
      <Grid item xs={12} sx={{ mb: 2 }}>
        <CircumstanceGroup data={circFatoApreensao} />
      </Grid>
      <Grid item xs={12} display='flex' justifyContent='left' sx={{ mb: -2 }}>
        <StyledLabelHeading>
          Informado sobre seu direito constitucional de permanecer em silêncio e cientificado do
          teor da documentação advinda da Delegacia de Polícia, noticiando sobre a prática, em tese,
          de ato infracional, o adolescente assim declarou:
        </StyledLabelHeading>
      </Grid>
      <Grid item xs={12} sx={{ mb: 2 }}>
        <Label text='NARRATIVA DO ADOLESCENTE' v='h6' bold />
        <Divider />
        {narrativa && narrativa.narrativaAdolescente && (
          <Grid container direction='column' spacing={1} sx={{ mt: 1 }}>
            <Grid item>
              <Label text='Narrativa do adolescente:' sx={{ fontSize: 14 }} bold />
              <Span
                className='ql-editor'
                fontWeight={400}
                dangerouslySetInnerHTML={{ __html: narrativa.narrativaAdolescente }}
              />
            </Grid>
          </Grid>
        )}
      </Grid>
      <Grid item xs={12} sx={{ mb: 2 }}>
        <Label text='NARRATIVA DO REPRESENTANTE LEGAL' v='h6' bold />
        <Divider />
        {narrativa && narrativa.narrativaRepLegal && (
          <Grid container direction='column' spacing={1} sx={{ mt: 1 }}>
            <Grid item>
              <Label text='Narrativa do representante legal:' sx={{ fontSize: 14 }} bold />
              <Span
                className='ql-editor'
                fontWeight={400}
                dangerouslySetInnerHTML={{ __html: narrativa.narrativaRepLegal }}
              />
            </Grid>
          </Grid>
        )}
      </Grid>
      <Grid item xs={12} sx={{ mb: 2 }}>
        <InfractionGroup data={narrativa} />
      </Grid>
    </Grid>
  )
}
